





















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: {
    // if this is not here, the thing won't work?? :^)))))))
  }
})

export default class ButtonComponent extends Vue {
  @Prop() public btnType!: string; // primary, secondary, tertiary
  @Prop() public btnSize!: string; // large, medium, small
  @Prop() public btnText!: string;
  @Prop() public btnText2?: string;
  @Prop() public isLoading?: boolean
  @Prop() public sticky?: boolean;
  @Prop() public fullwidth?: boolean;
  @Prop() public inactive?: boolean;
  @Prop() public btnIconSrc?: string;

  public btnClick () {
    if (!this.isLoading) {
      this.$emit('btnClick')
    }
  }
}
